
import React from 'react';
import { cn } from '@/lib/utils';
import { RadioGroup, RadioGroupItem } from './radio-group';

interface RadioGroupWithChildrenProps extends React.ComponentPropsWithoutRef<typeof RadioGroup> {
  children: React.ReactNode;
}

export const RadioGroupWithChildren = React.forwardRef<
  HTMLDivElement,
  RadioGroupWithChildrenProps
>(({ className, children, ...props }, ref) => (
  <RadioGroup ref={ref} className={cn(className)} {...props}>
    {children}
  </RadioGroup>
));

RadioGroupWithChildren.displayName = 'RadioGroupWithChildren';

// Re-export RadioGroupItem
export { RadioGroupItem };
